import template        from "./button-fermentation-inoculate.html";
import css             from "./button-fermentation-inoculate.css";

import {Button}   	   from "gui";


class InoculateFermentationButton extends Button {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-button-fermentation-inoculate", InoculateFermentationButton);
  }
  static get schema() {
    return({
      "description": "User defined button that is disabled when there is not running fermentation",
      "type": "object",
      "properties": {}
    });
  }
  static get designer() {
    return({
      "category": "User Defined",
      "icon": {"context": "actions", "size": 16, "iconname": "insert-button"}
    });
  }
  constructor(...args) {
    super(...args);

    this.disabled = true;

    this.addEventListener("click", this.onclick_handler.bind(this));
    document.addEventListener("onupdatefermentations", this.onupdatefermentations_handler.bind(this));
  }
  onupdatefermentations_handler(event) {
    var fermentations = event.detail;

    this.disabled = true;

    for (const fermentation of fermentations) {  
      if (fermentation.running && !fermentation.inoculationDate) {
        this.disabled = false;
        this.__id = fermentation.id;
      }
    }
  }
  async onclick_handler() {
    if (!(await confirm("Are you sure you wish to inoculate?"))) return;
    var fermentation = await server.rcall("RM_fermentation_load", this.__id);
    fermentation.inoculationDate = new Date();
    await server.rcall("RM_fermentation_save", fermentation);
    alert("Inodulation date successfully registered.");
  }
}

InoculateFermentationButton.constructor();

export default InoculateFermentationButton;